// TODO add access token
// TODO add CSRF token
export class DataService {
  private static instance: DataService;
  private baseDomain: string;

  private constructor(baseDomain: string) {
    this.baseDomain = baseDomain;
  }

  // TODO: perhaps remove, can't get lms_finish to work
  postForm<T>(url: string, data: object): Promise<T> {
    return fetch(this.baseDomain + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json() as Promise<T>;
    });
  }

  post<T>(url: string, data: object, options: { signal?: AbortSignal; keepalive?: boolean } = {}): Promise<T> {
    const { signal, keepalive } = options;
    let csrfToken: string | undefined;
    try {
      csrfToken = (document.querySelector('[name="csrf-token"]') as HTMLMetaElement)?.content;
      if (!csrfToken) {
        throw new Error('CSRF token not found');
      }
    } catch (err) {
      return Promise.reject(new Error('CSRF token not found'));
    }
    return fetch(this.baseDomain + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-Token': csrfToken,
      },
      body: JSON.stringify(data),
      keepalive: keepalive ?? false,
      signal,
    }).then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json() as Promise<T>;
    });
  }

  get<T>(url: string, signal?: AbortSignal): Promise<T> {
    return fetch(this.baseDomain + url, {
      method: 'GET',
      headers: {},
      signal,
    }).then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json() as Promise<T>;
    });
  }

  // TODO: implement
  // delete() {}

  // TODO: implement
  // put() {}

  public static getInstance(baseDomain: string): DataService {
    if (!DataService.instance) {
      DataService.instance = new DataService(baseDomain);
    }

    return DataService.instance;
  }
}
